import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-metas',
  templateUrl: './metas.component.html',
  styleUrls: ['./metas.component.scss']
})
export class MetasComponent implements OnInit {

  @Input() metas: any;

  constructor() { }

  ngOnInit() {
  }

}
